import script from "./BrandsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandsSection.vue?vue&type=script&setup=true&lang=js"

import "./BrandsSection.vue?vue&type=style&index=0&id=4cef25cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cef25cc"]])

export default __exports__